import { prisma, OrderStatus, Ticket, ResourceType, ActionType } from "client";
import { getTicketCategory } from "../ticketCategory";

export const getTicketGroupQuantities = async (
  userId: string,
  groupId: string
) => {
  try {
    const ticketGroup = await getTicketCategory(userId, groupId);
    const ticketIds = ticketGroup?.tickets.map((ticket: Ticket) => ticket.id);

    if (!ticketIds?.length) {
      return {};
    }
    let quantity = ticketGroup?.quantity;

    const reservedTicketCount = await getTicketsCount(
      ticketIds,
      OrderStatus.ON_GOING
    );

    const completedOrder = await getTicketsCount(
      ticketIds,
      OrderStatus.COMPLETED
    );
    const availableTicketCount = quantity
      ? quantity - (reservedTicketCount || 0) - (completedOrder || 0)
      : 0;

    return {
      reservedTicket: reservedTicketCount,
      availableTicket: availableTicketCount,
      completedOrder: completedOrder,
    };
  } catch (e) {
    console.error(e);
  }
};
const getTicketsCount = async (ticketIds: string[], status: OrderStatus) => {
  try {
    const totalOrderCount = await prisma.orderItem.count({
      where: {
        ticketId: {
          in: ticketIds,
        },
        order: {
          status: {
            equals: status,
          },
        },
      },
    });
    return totalOrderCount || 0;
  } catch (e) {
    console.error(e);
  }
};
